import AddIcon from '@mui/icons-material/Add';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
// import { Box, Button, Grid, Paper, Stack } from '@mui/material';
import { Box, Grid, Paper, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getAllResponses,
  getInformationReqTemplatesByJob,
  getRecruiterSMTPAccounts,
  InformationReqResponse,
  ISMTPAccountsResponse,
  saveInformationReqResponse,
} from 'wisestep-api';
import {
  WsButton,
  WsColors,
  WsDialog,
  WsIconText,
  WsTypography,
  WsTypoVariants,
  getDateUsingFormat,
} from 'wisestep-base';

import { findSurveyResponse } from '../../../components/SurveyBuilder/CommonResponse';
import SurveyInfoByJobComponent from '../../../components/SurveyBuilder/SurveyInfoByJobComponent';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

import DefaultEmailModal from './DefaultEmailModal';
import { InformationCategoryMappingDialog } from './InformationCategoryMappingDialog';
import ShareCandidateByJob from './ShareCandidateByJob';

interface survayResponseData {
  ques: string;
  ans: string;
}

export const InformationRequests = ({ candidate }) => {
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [showSurvey, setShowSurvey] = useState(false);
  const [templateJsonObject, setTemplateJsonObject] = useState('');
  const [informationJobId, setInformationJobId] = useState<string>('');
  const [selectedInfoReqResponsesId, setSelectedInfoReqResponsesId] = useState<string>('');
  const [mappedTemplates, setMappedTemplates] = useState<any[]>();
  const [infoReqResponses, setInfoReqResponses] = useState<InformationReqResponse[]>();
  const [shareCandidateByyJob, setShareCandidateByJob] = useState<boolean>(false);
  const [editMode, setEditMode] = useState(true);
  const [responseData, setResponseData] = useState<survayResponseData[]>();
  const [recruiterName, setRecruiterName] = useState<string>('');
  const [showViewSurveyResponse, setShowViewSurveyResponse] = useState<boolean>(false);
  const [defaultSmtpEmail, setDefaultSmtpEmail] = useState<string | undefined>('');
  const [showEmailPopup, setShowEmailPopup] = useState<boolean>(false);
  const onWidgetClose = useConversationWidgetStore((state) => state.onWidgetClose);

  useEffect(() => {
    (async () => {
      const smtpResponse = await getRecruiterSMTPAccounts();
      if (smtpResponse && smtpResponse.data) {
        const allEmails: ISMTPAccountsResponse[] = smtpResponse.data;
        let defaultEmail = allEmails.find((email) => email.isDefault);
        if (!defaultEmail && allEmails.length > 0) {
          defaultEmail = allEmails[0];
        }
        setDefaultSmtpEmail(defaultEmail?.fromEmail);
      }
    })();
  }, []);

  const fetchMappedTemplates = async () => {
    try {
      const templatesResponse = await getInformationReqTemplatesByJob(candidate.jobId ?? '');
      const data = templatesResponse.data;
      setMappedTemplates(data);
      const recruiterNames = data.map((item) => item.recruiterName);
      setRecruiterName(recruiterNames);

      const responsesResponse = await getAllResponses(
        candidate.candidateId + '_' + candidate.jobId,
        candidate.jobId,
        defaultSmtpEmail ?? ''
      );
      const NonRtrData = responsesResponse.data.filter(
        ({ informationReqTemplate }) => !informationReqTemplate.rtrTemplate
      );
      setInfoReqResponses(NonRtrData);
    } catch (error) {
      console.error('Error fetching templates:', error);
    }
  };

  useEffect(() => {
    fetchMappedTemplates();
    setShowViewSurveyResponse(false);
    setResponseData([]);
  }, []);

  const handleCloseDialog = async () => {
    setOpenDialog(false);
    await fetchMappedTemplates();
  };

  const handleSendRequest = async (infoReqResponse) => {
    if (!defaultSmtpEmail) {
      setShowEmailPopup(true);
    } else {
      setSelectedInfoReqResponsesId(infoReqResponse.id);
      setInformationJobId(infoReqResponse.id);
      setShareCandidateByJob(true);
      try {
        await fetchMappedTemplates();
      } catch (error) {
        console.log('error', error);
      }
    }
  };

  const handleAddResponse = (infoReqResponse) => {
    setSelectedInfoReqResponsesId(infoReqResponse.id);
    setShowSurvey(true);
    setTemplateJsonObject(
      JSON.parse(JSON.stringify(infoReqResponse.informationReqTemplate.category))
    );
    setEditMode(true);
  };

  const submitFeedback = async (ques, ans) => {
    try {
      await saveInformationReqResponse({
        response: findSurveyResponse(ques, ans),
        id: Number(selectedInfoReqResponsesId),
      });

      fetchMappedTemplates();
    } catch (error) {
      console.error('Error calling saveInformationReqResponse API:', error);
    }
    setShowSurvey(false);
  };

  const callBackSentRequest = () => {
    setShareCandidateByJob(false);
    fetchMappedTemplates();
  };

  const handleViewResponse = (infoReqResponse) => {
    setEditMode(false);
    setShowSurvey(true);
    const keys = Object.keys(infoReqResponse.response);
    const feedbackArray = keys.map((ques) => ({
      ques,
      ans: infoReqResponse.response[ques].toString(),
    }));
    setTemplateJsonObject(
      JSON.parse(JSON.stringify(infoReqResponse.informationReqTemplate.category))
    );
    setResponseData(feedbackArray);
    setShowViewSurveyResponse(true);
  };

  const showBackInfoList = () => {
    setShowSurvey(false);
    setShowViewSurveyResponse(false);
    setResponseData([]);
  };

  return (
    <>
      {showSurvey ? (
        <>
          <SurveyInfoByJobComponent
            surveyJson={templateJsonObject}
            feedbackDataBack={submitFeedback}
            callShowBackInfoList={showBackInfoList}
            isEditMode={editMode}
            responseData={responseData}
            survayResponse={showViewSurveyResponse}
            showBackButton={true}
          />
        </>
      ) : (
        <Stack sx={{ backgroundColor: WsColors.White, p: 2 }}>
          {/* <Button
            startIcon={<AddIcon />}
            variant="contained"
            sx={{ alignSelf: 'flex-end' }}
            onClick={() => setOpenDialog(true)}
          >
            Information Template
          </Button> */}
          <Box flexGrow={1} style={{ maxHeight: '600px', overflowY: 'auto' }}>
            {infoReqResponses?.map((infoReqResponse, index: number) => (
              <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5, mt: 3 }} key={index}>
                <Stack justifyContent="space-between">
                  <WsTypography variant={WsTypoVariants.SUB_TITLE}>
                    {infoReqResponse.informationReqTemplate?.categoryName}
                  </WsTypography>
                  <Stack direction="row" px="11px" sx={{ opacity: '65%', mt: 1 }} spacing={2}>
                    <WsIconText
                      textCursor="pointer"
                      popOverText="Information template tagged by"
                      icon={<WorkOutlineIcon sx={{ fontSize: '20px' }} />}
                      text={
                        recruiterName[index]
                          ? ` ${recruiterName[index]} (${
                              infoReqResponse.informationReqTemplate?.createdBy ?? ''
                            })`
                          : (infoReqResponse.informationReqTemplate?.createdBy as string)
                      }
                      textSize={WsTypoVariants.BODY1}
                    />
                    <WsIconText
                      textCursor="pointer"
                      popOverText="Information template tagged on"
                      icon={<WorkOutlineIcon sx={{ fontSize: '20px' }} />}
                      text={getDateUsingFormat(
                        infoReqResponse.informationReqTemplate?.createdOn as string,
                        'DD-MMM-YY'
                      )}
                      textSize={WsTypoVariants.BODY1}
                    />
                  </Stack>
                  <Box mt={2} sx={{ marginLeft: 'auto' }}>
                    <Grid container spacing={1}>
                      {!infoReqResponse.sendRequest && !infoReqResponse.submittedBy && (
                        <Grid item>
                          <WsButton
                            variant="contained"
                            size="small"
                            onClick={() => handleSendRequest(infoReqResponse)}
                          >
                            Send Request
                          </WsButton>
                        </Grid>
                      )}
                      {!infoReqResponse.submittedBy ? (
                        <Grid item>
                          <WsButton
                            startIcon={<AddIcon />}
                            variant="contained"
                            size="small"
                            onClick={() => handleAddResponse(infoReqResponse)}
                          >
                            Add Candidate Info
                          </WsButton>
                        </Grid>
                      ) : (
                        <Grid item>
                          <WsButton
                            variant="contained"
                            size="small"
                            onClick={() => handleViewResponse(infoReqResponse)}
                          >
                            View Information
                          </WsButton>
                        </Grid>
                      )}
                    </Grid>
                  </Box>
                </Stack>
              </Paper>
            ))}
          </Box>
        </Stack>
      )}

      {openDialog && (
        <WsDialog openDialog={openDialog}>
          <InformationCategoryMappingDialog
            handleCloseDialog={handleCloseDialog}
            jobId={candidate.jobId}
            mappedTemplates={mappedTemplates}
          />
        </WsDialog>
      )}
      {shareCandidateByyJob && (
        <ShareCandidateByJob
          interactionId={candidate.candidiateId}
          jobTitle={candidate?.mappedJobTitle ?? ''}
          jobCode={candidate.jobCode ?? ''}
          jobId={candidate.jobId ?? ''}
          name={candidate.name}
          jobLocation={candidate.mappedJobLocation ?? ''}
          email={candidate.email}
          informationTemplateId={informationJobId}
          infoReqResponsesId={selectedInfoReqResponsesId}
          onSentRequest={callBackSentRequest}
          id={candidate.id}
          onClose={() => {
            setShareCandidateByJob(false);
          }}
          reset={() => {
            setShareCandidateByJob(false);
            setTimeout(() => setShareCandidateByJob(false), 600);
          }}
        />
      )}
      {showEmailPopup && (
        <WsDialog openDialog={showEmailPopup} onClose={() => setShowEmailPopup(false)}>
          <DefaultEmailModal
            title="Email not configured"
            text="No email is configured for your Wisestep Account."
            content="To configure your email, please click on 'Configure'"
            confirm={() => {
              setShowEmailPopup(false);
              navigate('/email-settings');
              onWidgetClose();
            }}
            close={() => setShowEmailPopup(false)}
            confirmButtonText="Configure"
          ></DefaultEmailModal>
        </WsDialog>
      )}
    </>
  );
};
